import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ShowModalService {
  private bsModalRefs: BsModalRef[] = [];
  private subs: Subscription[] = [];
  private onHideEvents: any[] = [];
  public bsModalRef: BsModalRef;

  constructor(private modalService: BsModalService) {}

  show(content: any, sizeClass: string, initialState?: {}, onHide?: () => any) {
    if (!content) return;

    this.bsModalRefs.unshift(
      (this.bsModalRef = this.modalService.show(content, {
        initialState,
        class: sizeClass,
        backdrop: 'static',
        keyboard: false,
      }))
    );

    this.onHideEvents.unshift(onHide);

    this.subs.unshift(
      this.modalService.onHide.subscribe((_) => {
        const fnOnHide = this.onHideEvents.shift();

        if (fnOnHide) fnOnHide();

        this.unSubscribe();
      })
    );
  }

  hide() {
    this.bsModalRefs.shift().hide();
  }

  private unSubscribe() {
    this.subs.shift().unsubscribe();
  }
}
